module.exports = __webpack_public_path__ + "img/Workflow_icon03.f606320a.png";